// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1kg4-","display":"Video_display__1dUPT","iframe":"Video_iframe__2s-k7","description":"Video_description__25Aw0"};